(function(){
  function update(car){
    var t=car.querySelector('.mg-car-track'); if(!t) return;
    var p=car.querySelector('.mg-car-btn--prev'), n=car.querySelector('.mg-car-btn--next');
    var max=t.scrollWidth-t.clientWidth-2;
    if(p) p.disabled=t.scrollLeft<=2;
    if(n) n.disabled=t.scrollLeft>=max;
  }
  function init(root){
    (root||document).querySelectorAll('[data-mg-car]').forEach(function(car){
      if(car.__mg) return; car.__mg=true;
      var t=car.querySelector('.mg-car-track'); if(!t) return;
      t.addEventListener('scroll',function(){update(car);},{passive:true});
      car.addEventListener('click',function(e){
        var b=e.target.closest('.mg-car-btn'); if(!b) return;
        var dir=b.classList.contains('mg-car-btn--prev')?-1:1;
        t.scrollBy({left:dir*t.clientWidth*0.9,behavior:'smooth'});
      });
      window.addEventListener('resize',function(){update(car);});
      update(car);
    });
  }
  if(document.readyState!=='loading'){init();}else{document.addEventListener('DOMContentLoaded',function(){init();});}
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
})();
